module.exports = {"events_list":{"button_load_more":["Charger plus...","Load more..."],"no_item_found":["Il n'y a aucune événement correspondant à vos critères de recherche.","There is nothing found matching your search criteria."]}}


//////////////////
// WEBPACK FOOTER
// ./src/features/Events/translations/translations_events_list.json
// module id = 1471
// module chunks = 0